import { TRANSLATION_KEYS } from '../../../../translations'
import { getNavigationSteps } from '../../../navigation'

const steps = [TRANSLATION_KEYS.navigation.settings, TRANSLATION_KEYS.navigation.attachments]
export const QBR_DOCUMENT_UPLOAD_STEPS = getNavigationSteps(steps)
